import styled from 'styled-components';

export const OrangeButton = styled.div`
    cursor: pointer; 
    display: inline-block;
    padding: 0.5rem 2.5rem;
    text-align: center;
    color: white;
    font-family: 'Piers-Bold';
    font-size: 15pt;
    background: rgb(255,3,84);
    background: linear-gradient(90deg, rgba(255,3,84,1) 0%, rgba(255,171,0,1) 100%); 
    border-radius: 25px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    white-space: nowrap;
`;